import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom'; // Import useNavigate

function BookTaxiPage() {
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');
  const [date, setDate] = useState('');
  const [bookingDetails, setBookingDetails] = useState(null);

  const navigate = useNavigate(); // Initialize useNavigate hook

  const handleSubmit = (e) => {
    e.preventDefault();
    setBookingDetails({ from, to, date });

    // Redirect to the booking section
    navigate('/booking');
  };

  return (
    <div style={{ padding: '50px', backgroundColor: '#f0f4f8', minHeight: '100vh' }}>
      <div style={{ maxWidth: '600px', margin: '0 auto', backgroundColor: '#fff', padding: '30px', borderRadius: '8px', boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)' }}>
        <h1 style={{ textAlign: 'center', color: '#E05C35' }}>Book Your Taxi</h1>

        {/* Form */}
        {!bookingDetails ? (
          <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="from" style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>City From:</label>
              <input
                type="text"
                id="from"
                value={from}
                onChange={(e) => setFrom(e.target.value)}
                required
                placeholder="Enter city from"
                style={{
                  padding: '12px',
                  width: '100%',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                  fontSize: '16px',
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="to" style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>City To:</label>
              <input
                type="text"
                id="to"
                value={to}
                onChange={(e) => setTo(e.target.value)}
                required
                placeholder="Enter city to"
                style={{
                  padding: '12px',
                  width: '100%',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                  fontSize: '16px',
                }}
              />
            </div>

            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="date" style={{ fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>Date:</label>
              <input
                type="date"
                id="date"
                value={date}
                onChange={(e) => setDate(e.target.value)}
                required
                style={{
                  padding: '12px',
                  width: '100%',
                  borderRadius: '8px',
                  border: '1px solid #ccc',
                  boxSizing: 'border-box',
                  fontSize: '16px',
                }}
              />
            </div>

            <button
              type="submit"
              style={{
                backgroundColor: '#E05C35',
                color: 'white',
                padding: '15px 0',
                border: 'none',
                borderRadius: '8px',
                cursor: 'pointer',
                fontSize: '18px',
                fontWeight: 'bold',
                transition: 'background-color 0.3s ease',
              }}
              onMouseOver={(e) => (e.target.style.backgroundColor = '#D04B2B')}
              onMouseOut={(e) => (e.target.style.backgroundColor = '#E05C35')}
            >
              Search
            </button>
          </form>
        ) : (
          <div style={{ marginTop: '30px', padding: '20px', backgroundColor: '#f9f9f9', borderRadius: '8px' }}>
            <h2 style={{ color: '#4CAF50' }}>Your Booking</h2>
            <p>
              You are booking a taxi from <strong>{bookingDetails.from}</strong> to{' '}
              <strong>{bookingDetails.to}</strong> on <strong>{bookingDetails.date}</strong>.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}

export default BookTaxiPage;
